import i18n from '../../../../i18n'
import {
  STATISTIC_CONTACT_TAB,
  STATISTIC_ROLE_TAB,
  STATISTIC_STATUS_TAB,
  STATISTIC_SUMMARY_TAB,
} from '../InhabitantsStatisticModal.constants'

export function getStatisticTabs() {
  return [
    {
      id: STATISTIC_ROLE_TAB,
      text: i18n.t('Inhabitant.StatisticRoleTabKey'),
    },
    {
      id: STATISTIC_STATUS_TAB,
      text: i18n.t('Inhabitant.StatusRoleTabKey'),
    },
    {
      id: STATISTIC_CONTACT_TAB,
      text: i18n.t('Inhabitant.StatisticContactTabKey'),
    },
    {
      id: STATISTIC_SUMMARY_TAB,
      text: i18n.t('Inhabitant.StatisticSummaryTabKey'),
    },
  ]
}
